import { James, Vera, Joe, Leighton, Oisin, Sam, Steve } from './HelpTeamGraphic';
import { Region } from '../../../utils/regionUtils';
import { HelpTeamGraphicOption, TeamMember } from './types';

const TEAM_MEMBERS: TeamMember[] = [
  { icon: Vera, name: 'Vera', region: 'canada' },
  { icon: Leighton, name: 'Leighton', region: 'canada' },
  { icon: Sam, name: 'Sam', region: 'australia' },
  { icon: Steve, name: 'Steve', region: 'australia' },
  { icon: James, name: 'James', region: 'australia' },
  { icon: Joe, name: 'Joseph', region: 'australia' },
  { icon: Oisin, name: 'Oisin', region: 'australia' }
];

const DESCRIPTION_TEMPLATE =
  "I'm {name}, part of the Scout team\n based in {region}. Let us help you!";

const createDescription = (name: string, region: string): string => {
  const regionDisplay =
    region === 'canada' ? 'North America' : `${region.charAt(0).toUpperCase()}${region.slice(1)}`;
  return DESCRIPTION_TEMPLATE.replace('{name}', name).replace('{region}', regionDisplay);
};

const groupTeamMembersByRegion = (): Record<Region, HelpTeamGraphicOption[]> => {
  return TEAM_MEMBERS.reduce(
    (grouped, member) => {
      if (!grouped[member.region]) {
        grouped[member.region] = [];
      }

      grouped[member.region].push({
        icon: member.icon,
        description: createDescription(member.name, member.region)
      });

      return grouped;
    },
    {} as Record<Region, HelpTeamGraphicOption[]>
  );
};

export const helpTeamGraphicOptions = groupTeamMembersByRegion();
